module.exports = ".modal-text {\n  font-size: 1.4em;\n  line-height: 1.3em; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.scss
// module id = ./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.scss
// module chunks = 0